<div id="fat-zebra-iframe" *ngIf="iframeUrl">
  <iframe class="fat-zebra-iframe" [src]="sanitizedUrl()"></iframe>
</div>
